import Router from 'vue-router'
import goTo from '../node_modules/vuetify/es5/services/goto'
// Vuex
import store from './store.js';

//const HelloWorld = () => import('./components/HelloWorld.vue')
// const Test = () => import('./components/Test.vue')
// const temp = () => import('./components/TestReserve.vue')
//  const Home = () => import('./components/HelloWorld.vue')
const Home = () => import('./components/top/Index.vue')
const stockOrderAnalyze = () => import('./components/stockOrderAnalyze/Index.vue')
const stockOrderAnalyzeDetail = () => import('./components/stockOrderAnalyze/Detail.vue')
const currentStocks = () => import('./components/currentStocks/Index.vue')
const StockMaterialHistories = () => import('./components/stockMaterialHistories/Index.vue')
const StockMaterialHistoryDetail = () => import('./components/stockMaterialHistories/Detail.vue')
const stockOutOrders = () => import('./components/stockOutOrders/Index.vue')
const stockOutOrdersDetail = () => import('./components/stockOutOrders/Detail.vue')
const stockOrderOutPrint = () => import('./components/stockOutOrders/StockOrderOutPrint.vue')
const stockOrdersOutPrint = () => import('./components/stockOutOrders/StockOrdersOutPrint.vue')
const stockInOrders = () => import('./components/stockInOrders/Index.vue')
const stockInOrdersDetail = () => import('./components/stockInOrders/Detail.vue')
const stockOrderInPrint = () => import('./components/stockInOrders/stockOrderInPrint.vue')
const stockOrdersInPrint = () => import('./components/stockInOrders/stockOrdersInPrint.vue')
const stockTakes = () => import('./components/stockTakes/Index.vue')
const stockTakeOrderDetail = () => import('./components/stockTakes/Detail.vue')
const stockTakeOrderPrint = () => import('./components/stockTakes/stockTakeOrderPrint.vue')
const stockTakeOrdersPrint = () => import('./components/stockTakes/stockTakeOrdersPrint.vue')
const stockDetails = () => import('./components/stockDetails/Index.vue')
const stockDetailsDetail = ()=> import('./components/stockDetails/Detail.vue')
const productionPlans = () => import('./components/productionPlans/Index.vue') //生产计划
const productionPlanDetail = () => import('./components/productionPlans/Detail.vue') //生产计划
const reportDownloads = () => import('./components/reportDownloads/Index.vue')
const shopDailyReports = () => import('./components/shopDailyReports/Index.vue')
const shopDailyReportsDetail = () => import('./components/shopDailyReports/Detail.vue')
const orders = () => import('./components/orders/Index.vue')
const orderDetails = () => import('./components/orders/Detail.vue')
const examines = () => import('./components/examines/Index.vue')
const examineDetail = () => import('./components/examines/Detail.vue')
const receipts = () => import('./components/receipts/Index.vue')
const receiptDetail = () => import('./components/receipts/Detail.vue')
const user = () => import('./components/user/Index.vue')
const TakeTemplates = () => import('./components/takeTemplates/Index.vue')
const takeTemplatesDetails = () => import('./components/takeTemplates/Detail.vue')
const Page403 = () => import('./components/Page403.vue')
const Page404 = () => import('./components/Page404.vue')

var router = new Router({
    routes: [
        { path: '/', component: Home },//首页
        { path: '/home', component: Home },//首页
        { path: '/from-admin/:from/:access_token', component: Home },//首页，接受品牌后台跳转
        { path: '/from-admin/:from/:access_token/:redirect', component: Home },//首页，接受品牌后台跳转
        { path: '/stock-order-analyze', component: stockOrderAnalyze },//出入库统计
        { path: '/stock-order-analyze/:id/', component: stockOrderAnalyzeDetail },//出入库明细
        { path: '/current-stocks', component: currentStocks },//当前库存
        { path: '/current-stocks/initialize', component: stockInOrdersDetail },//当前库存期初入库
        { path: '/current-stocks/detail/stock-material-history', component: StockMaterialHistories }, //历史库存一览
        { path: '/current-stocks/detail/stock-material-history-details/:id', component: StockMaterialHistoryDetail }, //历史库存详情
        { path: '/stock-out-orders', component: stockOutOrders },//出库
        { path: '/stock-out-orders/:id/', component: stockOutOrdersDetail },//出库单详情
        { path: '/stock-out-orders/:id/:mode', component: stockOutOrdersDetail },//出库单编辑、确认
        { path: '/stock-in-orders', component: stockInOrders },//入库
        { path: '/stock-in-orders/:id/', component: stockInOrdersDetail },//入库单详情
        { path: '/stock-in-orders/:id/:mode', component: stockInOrdersDetail },//入库单编辑、确认
        { path: '/stock-takes', component: stockTakes },//盘点
        { path: "/stock-takes/detail/:id", component: stockTakeOrderDetail}, //盘点详情
        { path: "/stock-takes/detail/:id/:mode", component: stockTakeOrderDetail }, //盘点功能
        { path: "/print/stock-take-order-print/:id", component: stockTakeOrderPrint}, //盘点单打印
        { path: "/print/stock-take-orders-print/", component: stockTakeOrdersPrint}, //盘点单批量打印
        { path: "/stock-details", component: stockDetails },//批次管理
        { path: "/stock-details/:id", component: stockDetailsDetail },//批次管理详情
        { path: "/production-plans", component: productionPlans },//生产计划一览
        { path: "/production-plans/:id", component: productionPlanDetail },//生产计划详情
        { path: "/production-plans/:id/:mode", component: productionPlanDetail },//生产计划编辑
        { path: "/production-plans/:id/:mode/:action", component: productionPlanDetail },//生产计划编辑
        { path: '/report-downloads', component: reportDownloads },//报表下载
        { path: '/shop-daily-reports', component: shopDailyReports }, // 门店销售营业统计
        { path: '/shop-daily-reports/:id', component: shopDailyReportsDetail }, // 门店销售营业统计详情
        { path: '/orders', component: orders },//订单一览
        { path: '/order-new', component: orderDetails },//订单新建
        { path: '/orders/:id', component: orderDetails },//订单详情
        { path: '/orders/:id/:mode', component: orderDetails },//订单编辑、确认
        { path: '/examines', component: examines },//验收一览
        { path: '/examines/:id', component: examineDetail },//验收详情
        { path: '/examines/:id/:mode', component: examineDetail },//确认验货
        { path: '/receipts', component: receipts }, // 应收应付
        { path: '/receipts/:id', component: receiptDetail }, // 应收应付详情
        { path: '/user', component: user }, // 用户信息
        { path: "/production-stock-out", component: stockOutOrders },//生产出库一览
        { path: "/production-stock-out/:id", component: stockOutOrdersDetail },//生产出库详情
        { path: "/production-stock-out/:id/:mode", component: stockOutOrdersDetail },//生产出库编辑，确认
        { path: "/print/stock-out-detail-print/:id", component: stockOrderOutPrint}, //出库单明细打印
        { path: "/print/stock-orders-out-print/", component: stockOrdersOutPrint}, //出库单批量打印
        { path: "/production-stock-in", component: stockInOrders },//生产入库一览
        { path: "/production-stock-in/:id", component: stockInOrdersDetail},//生产入库单详情
        { path: "/production-stock-in/:id/:mode", component: stockInOrdersDetail},//生产入库单编辑确认
        { path: "/print/stock-order-in-print/:id", component: stockOrderInPrint},//入库单打印
        { path: "/print/stock-orders-in-print/", component: stockOrdersInPrint },//入库单打印 批量
        { path: "/stock-takes/take-templates", component: TakeTemplates },//盘点模板一览
        { path: '/stock-takes/take-templates/:id', component: takeTemplatesDetails },//盘点模板明细
        { path: '/stock-takes/take-templates/:id/:mode', component: takeTemplatesDetails },//盘点模板明细
        
        // { path: '/test', component: Test },//！测试页，发布时要拿掉
        { path: '/page404', component: Page404 },//Page404
        { path: '/page403', component: Page403 },//Page404
        { path: '*', component: Page404 }
    ],
    scrollBehavior: (to, from, savedPosition) => {
        let scrollTo = 0;

        if (to.hash) {
            scrollTo = to.hash;
        } else if (savedPosition) {
            scrollTo = savedPosition.y;
        }

        return goTo(scrollTo);
    },
})

router.beforeEach((to, from, next) => {
    store.commit("searchDistrict", false);// 导航切换时默认关闭侧边栏的门店分组搜索控件
    next();
})

export default router